const compactNumberFormatter = new Intl.NumberFormat("en", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});

export const normalizeSkinKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/[\s_-]+/g, "")
    .replace(/[^a-z0-9]/g, "");

export const findSkinInfoByName = (skins, localId) => {
  const target = normalizeSkinKey(localId);
  if (!target || !Array.isArray(skins)) return null;
  return (
    skins.find((skin) => {
      const nameKey = normalizeSkinKey(skin?.name);
      const displayNameKey = normalizeSkinKey(skin?.display_name);
      return nameKey === target || displayNameKey === target;
    }) || null
  );
};

export const formatCompactSkinPrice = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return "0";
  return compactNumberFormatter.format(numeric).replace(/\s+/g, "");
};

export const getSkinUnlockSource = (skin) =>
  skin?.unlockSource ?? skin?.unlock_source ?? "shop";

export const isPremiumSkin = (skin) => getSkinUnlockSource(skin) === "premium";

export const isTreasureChestSkin = (skin) =>
  getSkinUnlockSource(skin) === "treasure_chest";

export const filterStaffOnlySkins = (skins, isStaff) =>
  (Array.isArray(skins) ? skins : []).filter(
    (skin) => !skin?.retired && (!skin?.staffOnly || Boolean(isStaff))
  );

export const isSkinAvailable = (skin) => Boolean(skin?.available);

export const isInsufficientDiamondBalanceError = (payload) => {
  const response = payload && typeof payload === "object" ? payload : {};
  const errorText = [
    response.code,
    response.error,
    response.detail,
    response.message,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    /not[\s_-]*enough[\s_-]*(gems?|diamonds?)/i.test(errorText) ||
    /insufficient[\s_-]*(gems?|diamonds?)/i.test(errorText) ||
    /недостаточно.*(гем|алмаз)/i.test(errorText) ||
    /nedostat(?:ok|ocne|očne).*(diamant|gem)/i.test(errorText)
  );
};

const skinSourceOrder = {
  shop: 0,
  premium: 1,
  treasure_chest: 2,
  staff: 3,
};

export const sortEventPickerSkins = (a, b) => {
  const sourceA = getSkinUnlockSource(a);
  const sourceB = getSkinUnlockSource(b);
  const sourceDiff =
    (skinSourceOrder[sourceA] ?? 3) - (skinSourceOrder[sourceB] ?? 3);
  if (sourceDiff !== 0) return sourceDiff;

  const rarityDiff = Number(a?.rarity || 0) - Number(b?.rarity || 0);
  if (rarityDiff !== 0) return rarityDiff;

  return String(a?.id || "").localeCompare(String(b?.id || ""));
};
